<template>
  <form method="post" v-on:submit.prevent="contact" class="form-pub">
    <div class="form-horizontal">
      <div class="form-group row">
        <div class="col-xs-12">
          <input v-model="values.name" id="name" name="name" class="form-control" type="text" placeholder="Your name*">
        </div>
      </div>

      <div class="form-group row">
        <div class="col-xs-12">
          <input v-model="values.email" id="email" name="email" class="form-control" type="email" placeholder="Your Email*">
        </div>
      </div>

      <div class="form-group row">
        <div class="col-xs-12">
          <input v-model="values.telephone" id="telephone" name="telephone" class="form-control" type="tel" placeholder="Your Phone Number">
        </div>
      </div>

      <div class="form-group row">
        <div class="col-xs-12">
          <input v-model="values.subject" id="subject" name="subject" class="form-control" type="text" placeholder="Subject*">
        </div>
      </div>

      <div class="form-group row">
        <div class="col-xs-12">
          <textarea v-model="values.body" id="message" name="message" class="form-control" placeholder="Message"></textarea>
        </div>
      </div>

      <div class="alert alert-danger" v-if="errors.length">
        <ul>
          <li v-for="error in errors">{{error}}</li>
        </ul>
      </div>

      <div class="xs-pt-10 submit">
        <vue-recaptcha ref="recaptcha" :sitekey="sitekey" @verify="onCaptchaVerified" @expired="onCaptchaExpired">
          <button type="submit" :disabled="status==='submitting'" class="btn-pub btn-pub-border-primary btn-pub-primary fixed-width xs-full-width" data-sitekey="6Lfh7YQUAAAAAFFo97nwwFbBJcN02XSKS_DxC8Vx">Submit</button>
        </vue-recaptcha>
      </div>
    </div>

  </form>
</template>


<script>
  import _ from 'underscore'
  import VueRecaptcha from 'vue-recaptcha';

  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'

export default {
    components: { VueRecaptcha },
    props: ['subject'],
    methods: {
      contact() {

        this.$refs.recaptcha.execute();

      },
      onCaptchaVerified: function (recaptchaToken) {
        if (!this.values.email) {
          this.errors.push('Please enter an email address');
        }
        if (!this.values.name) {
          this.errors.push('Please enter your name');
        }
        if (!this.values.subject) {
          this.errors.push('Please enter a subject');
        }

        if (!this.errors.length) {

          const self = this;
          self.$refs.recaptcha.reset();

          this.status = "submitting";
          this.$store.dispatch('contactus', {
            form: this.values,
            callback: (err) => {
              self.status = "";
              Toast.success('Inquiry sent successfully');
            },
          })
        }
      },
      onCaptchaExpired: function () {
        this.$refs.recaptcha.reset();
      }
    },

    computed: {
      ...mapState([
        'currentUser'
      ])
    },

    data() {
      return {
        sitekey: '6Lfh7YQUAAAAAFFo97nwwFbBJcN02XSKS_DxC8Vx',
        values: {
          email: null,
          name: null,
          telephone: null,
          body: null,
          subject: this.subject,

        },
        status: '',
        errors: [],
      }
    },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  form {padding:11%;background:#FFFFFF;}
  textarea { height: 190px; }

  @media only screen and (max-width:992px) {
    form {padding:5%;}
  }
</style>

<style>
  .grecaptcha-badge { z-index: 100; }
</style>



// WEBPACK FOOTER //
// InquiryForm.vue?445b2d49